import { Button, Container, Dropdown, DropdownButton } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './documentsDropDown.css';
import React, { useEffect, useState } from 'react';
import { getDocumentMenuItems } from '../../../services/documentService';
import { DocumentMenuBranch } from '../../../models/document';

const DocumentsDropDown = ({
  currentCategoryID,
  showDocumentSub,
  setShowDocumentSub,
}: {
  currentCategoryID: string | null;
  showDocumentSub: boolean;
  setShowDocumentSub: (param: boolean) => void;
}) => {
  const [shownSub, setShowSub] = useState('');
  const [menuItems, setMenuItems] = useState<DocumentMenuBranch[]>([]);
  const [subCurrentCategoryID, setSubCurrentCategoryID] = useState(
    window.localStorage.getItem('subCurrentCategoryID')
  );
  const [thirdCurrentCategoryID, setThirdCurrentCategoryID] = useState(
    window.localStorage.getItem('thirdCurrentCategoryID')
  );

  const navigate = useNavigate();

  const setMenu = async () => {
    const items = await getDocumentMenuItems();
    setMenuItems(items);
  };

  useEffect(() => {
    setMenu();
  }, []);

  useEffect(() => {
    if (currentCategoryID === 'document') {
      setShowDocumentSub(true);
    } else {
      setShowDocumentSub(false);
      setShowSub('');
    }
  }, [currentCategoryID]);

  useEffect(() => {
    setSubCurrentCategoryID(window.localStorage.getItem('subCurrentCategoryID'));
    setThirdCurrentCategoryID(window.localStorage.getItem('thirdCurrentCategoryID'));
  });

  const handleSecondItemSelect = (name: string) => {
    window.localStorage.setItem('currentCategoryID', 'document');
    window.localStorage.setItem('subCurrentCategoryID', name);
    window.localStorage.setItem('thirdCurrentCategoryID', '');
    currentCategoryID = 'document';
    
    console.log([window.localStorage.getItem("currentCategoryID"), window.localStorage.getItem("subCurrentCategoryID"), window.localStorage.getItem("thirdCurrentCategoryID")]);
  };

  const handleThirdItemSelect = (subName: string, name: string) => {
    window.localStorage.setItem('currentCategoryID', 'document');
    window.localStorage.setItem('subCurrentCategoryID', subName);
    window.localStorage.setItem('thirdCurrentCategoryID', name);
    currentCategoryID = 'document';
    console.log([window.localStorage.getItem("currentCategoryID"), window.localStorage.getItem("subCurrentCategoryID"), window.localStorage.getItem("thirdCurrentCategoryID")]);
  };

  return (
    <>
      {showDocumentSub ? (
        <Container className={`landing-page-dropdown-container col-12 bg-secondary justify-content-end`}>
          <div className="d-flex flex-nowrap ">
            {!!menuItems
              ? menuItems.map((it, idx) =>
                  !!it.itemLink && it.items?.length === 0 ? (
                    <Link
                      key={it.id}
                      onClick={() => {
                        handleSecondItemSelect(it.displayName);
                      }}
                      className={`${
                        it.displayName === subCurrentCategoryID ? 'btn-primary' : ''
                      } btn text-white pl-2 pr-2 company-document-sub-dropdown-link`}
                      to={it.itemLink}
                    >
                      {it.displayName}
                    </Link>
                  ) : (
                    <Dropdown
                      className="company-document-dropdown-button bg-secondary"
                      id="dropdown-basic-buttons"
                      show={shownSub === it.displayName}
                      key={it.id}
                      onToggle={() => {
                        if (shownSub === it.displayName) {
                          setShowSub('');
                        } else {
                          setShowSub(it.displayName);
                        }
                      }}
                    >
                      <Dropdown.Toggle
                        variant={`company-document-sub-dropdown-toggle ${
                          it.displayName === subCurrentCategoryID ? 'btn-primary' : ''
                        } text-white`}
                      >
                        {it.displayName ?? ''}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {!!it.items
                          ? it.items.map((ct) => (
                              <Dropdown.Item
                                className="company-document-sub-dropdown-child text-uppercase"
                                onClick={() => {
                                  handleThirdItemSelect(it.displayName, ct.displayName);
                                  navigate(ct.documentPath);
                                }}
                                key={ct.displayName}
                                active={ct.displayName === thirdCurrentCategoryID}
                              >
                                {ct.displayName}
                              </Dropdown.Item>
                            ))
                          : null}
                      </Dropdown.Menu>
                    </Dropdown>
                  )
                )
              : null}
            <div className="ml-auto"></div>
          </div>
        </Container>
      ) : null}
    </>
  );
};

export default DocumentsDropDown;
